import { z } from 'zod';

/**
 * Schema for application configuration passed to the WebRTC player app.
 * Contains the device thing name for context.
 */
export const AppConfigSchema = z.object({
  thingName: z.string(),
});

export type AppConfig = z.infer<typeof AppConfigSchema>;

/**
 * Schema for AWS credentials response.
 * Matches the shape of temporary AWS credentials with PascalCase keys.
 */
export const CredentialsResponseSchema = z.object({
  AccessKeyId: z.string(),
  SecretAccessKey: z.string(),
  SessionToken: z.string(),
  Expiration: z.string(),
  Region: z.string(),
});

export type CredentialsResponse = z.infer<typeof CredentialsResponseSchema>;
